import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { GameMutationKeys } from '../../../keys'
import {
	UpdateGameTypeProviderRequest,
	UpdateGameTypeProviderResponse,
} from '../../../type'
import { updateGameTypeProvider } from '../../services'

interface UpdateGameTypeProviderParams {
	id: string
	payload: UpdateGameTypeProviderRequest
}

export default function useMutationUpdateGameTypeProvider(
	props?: UseBaseMutationOptions<
		UpdateGameTypeProviderResponse,
		UpdateGameTypeProviderParams
	>,
) {
	return useMutation({
		mutationKey: [GameMutationKeys.UpdateGameTypeProviderGameType],
		mutationFn: (params) => updateGameTypeProvider(params.payload, params.id),
		...props,
	})
}
